import { Component, HostListener, Inject, Input, DOCUMENT, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../menu-options/menu.serive';
import { SettingsService } from '../settings/settings.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { ChatService } from '../chat-list/chat.service';
import { HeaderService } from '../header/header.service';
import { AlertPopup, HttpLoader, MENU_ICON, path } from 'app/app.config';
import { PlayerService } from '../media-player/media-player-service';

import { Subject } from 'rxjs';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { LlmService } from 'app/services/llm.service';
import { IndexedDBService } from 'app/services/indexed-db.service';

declare var bootstrap: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent {

  // @Input() menuList: any[];
  @Input() setting: any = {
    visible_sidebar: false
  };
  // @Input() isUserLoggedIn: boolean;
  @Input() currentUser: any;

  isToken: any;
  isUserRole: any;

  mediaContent: any = null;

  menuIcon: any = MENU_ICON;

  activeUserChannelList: any[] = [];
  activeChannel = false;
  singleSelect: any;
  companySearch: any;
  searchInList = new Subject<any>();
  isBelowIpadSize: boolean = false;
  isSidebarOpen: boolean = false;
  profileUrl = path.PROFILE_URL;
  companyUrl = path.COMPANY_URL;
  userDetail: any;
  menuList: any = [];

  private sidebarToggleHandler!: EventListener;

  subscribers: any = {
    notifyCount: null,
    media: null,
    router: null
  };

  @Input() collapsed = false;
  @Input() mobileOpen = false;
  @Input() isMobile = false;

  @Output() collapseChange = new EventEmitter<void>();
  @Output() closeMobile = new EventEmitter<void>();


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isBelowIpadSize && this.isSidebarOpen) {
      const sidebar = this.document.querySelector('.sidebar');
      const overlay = this.document.querySelector('.sidebar-overlay');
      const target = event.target as HTMLElement;

      // Close if clicking outside sidebar and overlay
      if (sidebar && !sidebar.contains(target) && overlay && !overlay.contains(target)) {
        // Don't close if clicking on the menu toggle button
        const menuToggle = this.document.querySelector('.navbar-burger');
        if (menuToggle && !menuToggle.contains(target)) {
          this.closeSidebar();
        }
      }
    }
  }


  ShowDropdown: boolean = false;

  hostlogo: any;
  constructor(
    private router: Router,
    private menuService: MenuService,
    private settingsService: SettingsService,
    private dataSharingService: DataSharingService,
    private chatService: ChatService,
    private headerService: HeaderService,
    private loader: HttpLoader,
    private alert: AlertPopup,
    private playerService: PlayerService,
    @Inject(DOCUMENT) private document: Document,
    private assistBotService: AssistBotService,
    private llmService: LlmService,
    private indexedDBService: IndexedDBService
    // private elibraryService: ELibraryService
  ) {

  }

  ngOnInit(): void {

    this.isToken = localStorage.getItem('token');

    if (this.isToken) {

      const role = localStorage.getItem('user_role');
      this.isUserRole = role ? Number(role.replace(/"/g, '')) : 0;

      this.getMenuList();

      setTimeout(() => {
        if (this.setting) {
          this.setting = {
            ...this.setting,
            visible_sidebar: false
          };
        }
      }, 10000);
    }

    this.updateScreenSize();

    this.sidebarToggleHandler = () => {
      if (this.isBelowIpadSize) {
        this.toggleSidebar();
      }
    };

    this.document.addEventListener(
      'sidebarToggle',
      this.sidebarToggleHandler
    );

    this.subscribers.router = this.router.events.subscribe(() => {

      setTimeout(() => {

        if (this.isBelowIpadSize) {
          this.closeSidebar();
        }

        const tooltip = this.document.querySelector('.ng-tooltip');

        if (tooltip?.classList.contains('ng-tooltip-show')) {
          tooltip.classList.remove('ng-tooltip-show');
        }

      }, 300);

    });

  }

  toggleCollapse(): void {

    if (this.isMobile) {
      this.closeMobile.emit();
      return;
    }

    this.collapseChange.emit();
  }

  onNavigation(): void {
    if (this.isMobile) {
      this.closeMobile.emit();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateScreenSize();
  }

  private updateScreenSize(): void {
    const width = window.innerWidth;
    this.isBelowIpadSize =
      width <= 640 || (width >= 765 && width <= 768);

    if (!this.isBelowIpadSize) {
      this.closeSidebar();
    }
  }

  getMenuList() {
    this.headerService.getCurrentUserDetail().subscribe(
      (user: any) => {

        
        const company = user.company_details;

        this.currentUser = company.logo;

        const isUser = user.userDetail;

        this.userDetail = isUser;

        console.log(this.userDetail);
        

        this.menuList = user.menuList;

        // const menuObj: any = {
        //   id: 1,
        //   display_menu: 'Dashboard',
        //   menu_name: 'dashboard'
        // };

        // this.menuList =
        //   [1, 2].includes(Number(isUser.user_role))
        //     ? [menuObj, ...user.menuList]
        //     : [...user.menuList];


        // const defaultMenuList = [
        //   {
        //     id: 1,
        //     display_menu: 'Dashboard',
        //     menu_name: 'dashboard'
        //   },
        //   // {
        //   //   id: 2,
        //   //   display_menu: 'Document New',
        //   //   menu_name: 'document_new'
        //   // }
        // ];

        // const userMenuList = Array.isArray(user?.menuList)
        //   ? user.menuList
        //   : [];

        // const isAdminRole = [1, 2].includes(Number(isUser?.user_role));

        // this.menuList = isAdminRole
        //   ? [...defaultMenuList, ...userMenuList]
        //   : [...userMenuList];

      });
  }



  ngAfterViewInit(): void {

    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );

    tooltipTriggerList.forEach((element: any) => {
      new bootstrap.Tooltip(element);
    });

    this.subscribers.notifyCount =
      this.dataSharingService.getNotifyCount().subscribe(menuObj => {

        const menu = this.menuList.find(
          (item: any) => item.menu_name === menuObj.menu
        );

        if (!menu) {
          return;
        }

        if (menuObj.count != null) {
          menu.notify_count = menuObj.count;
        } else {
          menu.notify_count = (menu.notify_count ?? 0) + 1;
        }

        this.menuList = [...this.menuList];

      });

    this.subscribers.media =
      this.playerService.getMediaContent().subscribe({

        next: response => {

          if (
            this.mediaContent &&
            response &&
            this.mediaContent.file_path !== response.file_path
          ) {
            this.mediaContent = response;
          } else if (!this.mediaContent) {
            this.mediaContent = response;
          }

        },

        error: err => console.error(err)

      });

    if (this.isToken) {

      this.settingsService.getUserSettings().subscribe((res: any) => {

        this.userDetail = res.userDetail;
        this.indexedDBService.userDetail = this.userDetail;

      });

    }

  }

  urlFormation(menuName: any) {
    if (menuName) {
      return menuName.replace(/_/g, '');
    }
  };

  private setSidebar(open: boolean): void {

    this.isSidebarOpen = open;

    const sidebar = this.document.querySelector('.sidebar');

    if (!sidebar) {
      return;
    }

    if (open) {
      this.document.body.style.overflow = 'hidden';
      sidebar.classList.add('show');
    } else {
      this.document.body.style.overflow = '';
      sidebar.classList.remove('show');
    }

  }

  toggleSidebar(): void {
    this.setSidebar(!this.isSidebarOpen);
  }

  openSidebar(): void {
    this.setSidebar(true);
  }

  closeSidebar(): void {
    this.setSidebar(false);
  }

  /**
 * Chang the hide sidemenu style
 * @param value
 */
  hideSideMenu(): void {
    // Initialize settings safely
    const currentSetting = this.setting ?? {
      visible_sidebar: false
    };

    const payload = {
      visible_sidebar: !currentSetting.visible_sidebar
    };

    this.setting = {
      ...currentSetting,
      ...payload
    };

    this.settingsService.updateUserSettings(payload).subscribe({
      error: (err) => {
        console.error('Failed to update sidebar settings:', err);
      }
    });

    if (this.isBelowIpadSize) {
      this.toggleSidebar();
    }
  }


  removeNotifyCount(menuObj: any) {
    menuObj.notify_count = 0;
  };

  showSearchBox(toggle: any) {
    console.log(toggle);

  }

  displayUserFirstLetter(userName: any) {
    if (userName) {
      return userName.charAt(0).toUpperCase();
    } else {
      return;
    }
  }

  showuserMenu() {
    this.ShowDropdown = !this.ShowDropdown;
  }

  toggleSideMenu(): void {
    if (this.isBelowIpadSize) {
      this.toggleSidebar();
      return;
    }

    const currentSetting = this.setting ?? {
      visible_sidebar: false
    };

    this.setting = {
      ...currentSetting,
      visible_sidebar: !currentSetting.visible_sidebar
    };
  }

  logout(): void {
    const userId = this.currentUser?.user_id;
    const companyId = localStorage.getItem('company_id');
    const llmToken = localStorage.getItem('llm_token');

    const payload = {
      user_id: userId,
      status_id: 0
    };

    // =====================================================
    // COMPLETE LOCAL LOGOUT
    // =====================================================

    const completeLogout = (): void => {
      // Clear application authentication/session data
      localStorage.clear();
      sessionStorage.clear();

      // Clear current user reference
      this.currentUser = null;

      // Replace current browser history entry
      // so user cannot simply return to the previous page
      window.history.replaceState(null, '', '/login');

      // Navigate to login and replace browser history
      this.router.navigate(['/login'], {
        replaceUrl: true
      });
    };

    // =====================================================
    // UPDATE USER STATUS
    // =====================================================

    const updateUserStatus = (): void => {
      if (!userId) {
        completeLogout();
        return;
      }

      this.headerService.updateStatus(payload).subscribe({
        next: () => {
          completeLogout();
        },

        error: (err) => {
          console.error('Update user status failed:', err);

          // Logout locally even if API fails
          completeLogout();
        }
      });
    };

    // =====================================================
    // LLM LOGOUT
    // =====================================================

    if (llmToken && companyId) {
      this.llmService
        .llmUserLogout({
          client_id: companyId
        })
        .subscribe({
          next: () => {
            updateUserStatus();
          },

          error: (err) => {
            console.error('LLM logout failed:', err);

            // Continue application logout
            updateUserStatus();
          }
        });
    } else {
      updateUserStatus();
    }
  }

  ngOnDestroy(): void {

    this.subscribers.notifyCount?.unsubscribe();
    this.subscribers.media?.unsubscribe();
    this.subscribers.router?.unsubscribe();

    if (this.sidebarToggleHandler) {
      this.document.removeEventListener(
        'sidebarToggle',
        this.sidebarToggleHandler
      );
    }

    this.document.body.style.overflow = '';

    this.activeChannel = false;

  }

}
